export const commandStateBinding = {
  cancelled: 'Annulé',
  courier: 'Ramassée',
  pickingPaused: 'Picking en pause',
  outOfStock: 'Rupture de stock',
  packingCompleted: 'Emballage terminé',
  toPack: 'À emballer',
  picking: 'A picker',
  ready: 'Prête à être expédiée'
};

export const stateOrders = [
  'picking',
  'outOfStock',
  'pickingPaused',
  'toPack',
  'packingCompleted',
  'ready',
  'courier'
];
